import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { ApiUrl } from "Services/Services";
import { FaEye } from "react-icons/fa6";
import { FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import beeps from "../../../assets/beep.mp3";

const Order = () => {
  const navigation = useNavigate();
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(10);
  const prevOrderIdsRef = useRef([]);

  const beep = () => {
    const audio = new Audio(beeps);
    audio.play().catch((err) => {
      console.warn("Beep play failed:", err.message);
    });
  };

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/order`);
      const newOrders = response.data.data;
      const newOrderIds = newOrders.map((order) => order.id);

      // Check for new order
      const isNewOrder = newOrderIds.some((id) => !prevOrderIdsRef.current.includes(id));

      if (prevOrderIdsRef.current.length > 0 && isNewOrder) {
        console.log(" New order detected!");
        beep();
      }

      setOrders(newOrders);
      prevOrderIdsRef.current = newOrderIds; 
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchOrders();
    const interval = setInterval(fetchOrders, 10000); 
    return () => clearInterval(interval);
  }, []);

  const statusSteps = ["pending", "preparing", "ready", "on_the_way", "delivered", "cancelled"];

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleStatusToggle = async (id) => {
    setOrders((prevOrders) =>
      prevOrders.map((order) => {
        if (order.id === id) {
          const currentIndex = statusSteps.indexOf(order.status);
          const nextIndex = (currentIndex + 1) % statusSteps.length;
          return { ...order, status: statusSteps[nextIndex] };
        }
        return order;
      })
    );

    try {
      const currentOrder = orders.find((order) => order.id === id);
      const currentIndex = statusSteps.indexOf(currentOrder.status);
      const nextIndex = (currentIndex + 1) % statusSteps.length;
      const newStatus = statusSteps[nextIndex];

      await axios.patch(`${ApiUrl}/orders/${id}/status`, { status: newStatus });
    } catch (error) {
      console.error("Failed to update order status:", error);
    }
  };

  const HandelView = (id) => {
    try {
      navigation(`/admin/viewOrder/${id}`);
    } catch (error) {
      console.log(error);
    }
  };

  const HandelDelete = async (id) => {
    try {
      const response = await axios.delete(`${ApiUrl}/order/${id}`);
      fetchOrders();
      toast.success("Order Deleted Successfully");
    } catch (error) {
      console.log(error);
    }
  };

 const getStatusColor = (status) => {
  switch (status) {
    case "pending":
      return { bg: "bg-yellow-100", text: "text-yellow-700" };
    case "accepted":
      return { bg: "bg-teal-100", text: "text-teal-700" };
    case "preparing":
      return { bg: "bg-blue-100", text: "text-blue-700" };
    case "ready":
      return { bg: "bg-purple-100", text: "text-purple-700" };
    case "assigned":
      return { bg: "bg-orange-100", text: "text-orange-700" };
    case "picked_up":
      return { bg: "bg-green-300", text: "text-green-700" };
    case "on_the_way":
      return { bg: "bg-green-500", text: "text-green-700" };
    case "delivered":
      return { bg: "bg-green-100", text: "text-green-700" };
    case "cancelled":
      return { bg: "bg-red-100", text: "text-red-700" };
    default:
      return { bg: "bg-gray-100", text: "text-gray-700" };
  }
};


  const getActionColor = (status) => {
    switch (status) {
      case "pending":
        return { view: "text-yellow-600", delete: "text-yellow-600" };
      case "preparing":
        return { view: "text-blue-600", delete: "text-blue-600" };
      case "ready":
        return { view: "text-purple-600", delete: "text-purple-600" };
      case "on_the_way":
        return { view: "text-orange-600", delete: "text-orange-600" };
      case "delivered":
        return { view: "text-green-600", delete: "text-green-600" };
      case "cancelled":
        return { view: "text-red-600", delete: "text-red-600" };
      default:
        return { view: "text-gray-600", delete: "text-gray-600" };
    }
  };

  return (
    <div className="p-6">
      
      <div className="bg-white shadow-md rounded-lg overflow-hidden min-h-96 ">
        <table className="min-w-full">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="px-6 py-4">#</th>
              <th className="px-6 py-4">Customer</th>
              <th className="px-6 py-4">Total (Rs)</th>
              <th className="px-6 py-4">Order Type</th>
              <th className="px-6 py-4">Address</th>
              <th className="px-6 py-4 text-center">Status</th>
              <th className="px-6 py-4 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentOrders.map((order, index) => {
              const customerName = order.User?.name ||order.Customer?.name;
              const itemList = order.items
                .map(
                  (item) =>
                    `${item.food?.name || "Unknown"} (${item.variation?.name || "N/A"}) x${item.quantity}`
                )
                .join("\n");
              const total = order.totalPrice;
              const orderType = order.orderType;
              const address = order.address;
              const statusColor = getStatusColor(order.status);
              const actionColor = getActionColor(order.status);

              return (
                <tr key={order.id} className="border-b hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium relative group">
                    {(currentPage - 1) * ordersPerPage + index + 1}
                    <div className="absolute left-0 top-full z-10 hidden group-hover:block bg-white border border-gray-300 shadow-md p-2 rounded w-64 text-sm whitespace-pre-wrap">
                      {itemList}
                    </div>
                  </td>
                  <td className="px-6 py-4">{customerName}</td>
                  <td className="px-6 py-4">{total}</td>
                  <td className="px-6 py-4">{orderType}</td>
                  <td className="px-6 py-4">{address}</td>
                  <td className="px-6 py-4 text-center">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium ${statusColor.bg} ${statusColor.text}`}
                    >
                      {order.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right space-x-2">
                    <button
                      onClick={() => HandelView(order.id)}
                      className={`${actionColor.view} hover:opacity-80`}
                    >
                      <FaEye />
                    </button>
                    <button
                      onClick={() => HandelDelete(order.id)}
                      className={`${actionColor.delete} hover:opacity-80`}
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {orders.length === 0 && (
          <div className="text-center py-6 text-gray-500 italic">No orders found.</div>
        )}

        {/* Pagination */}
        {orders.length > ordersPerPage && (
          <div className="flex justify-end py-4">
            <nav className="inline-flex rounded-md shadow mr-9">
              {Array.from({ length: Math.ceil(orders.length / ordersPerPage) }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => paginate(index + 1)}
                  className={`px-4 py-2 border ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  {index + 1}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};

export default Order;
